import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { MessageBoxType } from '../../types/message-box.type';

@Component({
    selector: 'lib-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class MessageBoxComponent implements OnInit {
    @Input() message: string;
    @Input() type: MessageBoxType;
    @Input() backgroundColor?: string;
    @Input() textColor?: string;
    @Input() messageBoxId?: string;

    styles: Record<string, string> = {};

    private readonly predefinedStyles: Record<
        'warning' | 'danger' | 'info' | 'success',
        { backgroundColor: string; color: string }
    > = {
        warning: { backgroundColor: '#fff3cd', color: '#856404' },
        danger: { backgroundColor: '#fbe7e7', color: '#e06363' },
        info: { backgroundColor: '#e3ecf2', color: '#175c89' },
        success: { backgroundColor: '#d4edda', color: '#155724' }
    };

    constructor() {
        this.message = '';
        this.type = null;
    }

    ngOnInit(): void {
        if (this.type && this.predefinedStyles[this.type]) {
            this.styles = this.predefinedStyles[this.type];
        } else {
            this.styles = {
                backgroundColor: this.backgroundColor ?? '#ffffff',
                color: this.textColor ?? '#000000'
            };
        }
    }
}
